import React from 'react';

export const OutlookMailSearchResultIcon = () => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M31.807 6.875H15.6906C14.9685 6.875 14.3744 7.46914 14.3744 8.19118V9.68723L23.4581 12.4997L33.1232 9.68723V8.19118C33.1232 7.46914 32.529 6.875 31.807 6.875Z"
			fill="#0364B8"
		/>
		<path
			d="M34.6699 21.3163C34.8073 20.8847 34.9169 20.4448 34.998 19.9992C34.9982 19.7762 34.879 19.5696 34.6859 19.4582L34.6738 19.4517L34.6699 19.4499L24.5099 13.6621C24.4661 13.6337 24.4207 13.6077 24.3741 13.5842C23.9807 13.3892 23.5179 13.3892 23.1244 13.5842C23.0778 13.6077 23.0324 13.6336 22.9885 13.6621L12.8286 19.4499L12.8248 19.4517L12.8125 19.4582C12.6195 19.5696 12.5004 19.7762 12.5005 19.9992C12.5816 20.4448 12.6913 20.8847 12.8286 21.3163L23.6016 29.1954L34.6699 21.3163Z"
			fill="#0A2767"
		/>
		<path
			d="M27.4985 9.68726H20.9364L19.0418 12.4998L20.9364 15.312L27.4985 20.9366H33.1231V15.312L27.4985 9.68726Z"
			fill="#28A8EA"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.3745 9.68726H20.9365V15.3118H14.3745V9.68726Z"
			fill="#0078D4"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M27.4987 9.68726H33.1233V15.3118H27.4987V9.68726Z"
			fill="#50D9FF"
		/>
		<path
			d="M27.4986 20.9365L20.9365 15.312H14.3745V20.9365L20.9365 26.5613L31.0909 28.2186L27.4986 20.9365Z"
			fill="#0364B8"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20.9366 15.312H27.4987V20.9365H20.9366V15.312Z"
			fill="#0078D4"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.3745 20.9366H20.9365V26.5612H14.3745V20.9366Z"
			fill="#064A8C"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M27.4987 20.9366H33.1233V26.5612H27.4987V20.9366Z"
			fill="#0078D4"
		/>
		<path
			d="M23.9279 28.6405L12.8717 20.5785L13.3348 19.7639C13.3348 19.7639 23.4076 25.501 23.5612 25.5873C23.6886 25.6384 23.8318 25.6343 23.956 25.576C24.0993 25.4954 34.204 19.7358 34.204 19.7358L34.669 20.5504L23.9279 28.6405Z"
			fill="#0A2767"
			fillOpacity="0.498039"
		/>
		<path
			d="M34.6859 20.5401L34.6738 20.5476L34.6709 20.5496L24.511 26.3374C24.1011 26.6016 23.5818 26.634 23.1423 26.4226L26.6811 31.167L34.4188 32.8516V32.8554C34.7836 32.5916 35.0001 32.1676 35 31.7173V19.9993C35.0001 20.2221 34.8808 20.4289 34.6878 20.5401H34.6859Z"
			fill="#1490DF"
		/>
		<path
			d="M34.9981 31.7173V31.0255L25.6396 25.6933L24.51 26.3364C24.1002 26.6007 23.5809 26.6331 23.1414 26.4216L26.6802 31.1661L34.4179 32.8506V32.8544C34.7826 32.5904 34.9991 32.1666 34.9991 31.7163L34.9981 31.7173Z"
			fill="black"
			fillOpacity="0.047059"
		/>
		<path
			d="M34.9513 32.0763L24.6928 26.2323L24.51 26.3363C24.1002 26.6006 23.5809 26.6331 23.1414 26.4216L26.6802 31.1661L34.4179 32.8506V32.8544C34.6804 32.664 34.8692 32.3887 34.9521 32.0753L34.9513 32.0763Z"
			fill="black"
			fillOpacity="0.098039"
		/>
		<path
			d="M12.8276 20.5524V20.543H12.8183L12.7901 20.5243C12.6082 20.4124 12.4977 20.2129 12.4995 19.9993V31.7192C12.4995 32.4896 13.1334 33.1235 13.9039 33.1235H33.5921C33.7091 33.1223 33.8257 33.1066 33.9388 33.0766C33.9976 33.0664 34.0545 33.0474 34.1077 33.0204C34.1276 33.0184 34.1467 33.012 34.1638 33.0016C34.2405 32.9702 34.313 32.9293 34.3794 32.8797L34.4169 32.8516L12.8276 20.5524Z"
			fill="#28A8EA"
		/>
		<path
			d="M21.8739 28.1241V12.8129C21.8719 12.1281 21.3091 11.5653 20.6243 11.5632H14.4035V18.5527L12.8275 19.4508L12.8239 19.4527L12.8117 19.4592C12.6186 19.5708 12.4995 19.7774 12.4995 20.0001V29.3774V29.3736H20.6243C21.3091 29.3716 21.8719 28.8087 21.8739 28.1241Z"
			fill="black"
			fillOpacity="0.098039"
		/>
		<path
			d="M20.9365 29.0614V13.7502C20.9345 13.0656 20.3716 12.5028 19.6869 12.5006H14.4035V18.5527L12.8275 19.4508L12.8239 19.4527L12.8117 19.4592C12.6186 19.5708 12.4995 19.7774 12.4995 20.0001V30.3149V30.3111H19.6869C20.3716 30.309 20.9345 29.7462 20.9365 29.0614ZM20.9365 27.1866V13.7502C20.9345 13.0656 20.3716 12.5028 19.6869 12.5006H14.4035V18.5527L12.8275 19.4508L12.8239 19.4527L12.8117 19.4592C12.6186 19.5708 12.4995 19.7774 12.4995 20.0001V28.4399V28.4362H19.6869C20.3716 28.4342 20.9345 27.8714 20.9365 27.1866ZM19.999 27.1866V13.7502C19.997 13.0656 19.4342 12.5028 18.7495 12.5006H14.4035V18.5527L12.8275 19.4508L12.8239 19.4527L12.8117 19.4592C12.6186 19.5708 12.4995 19.7774 12.4995 20.0001V28.4399V28.4362H18.7495C19.4342 28.4342 19.997 27.8714 19.999 27.1866Z"
			fill="black"
			fillOpacity="0.2"
		/>
		<path
			d="M6.24964 12.4999H18.7485C19.434 12.4999 19.9981 13.0639 19.9981 13.7494V26.2483C19.9981 26.9338 19.434 27.498 18.7485 27.498H6.24964C5.56414 27.498 5 26.9338 5 26.2483V13.7494C5 13.0639 5.56414 12.4999 6.24964 12.4999Z"
			fill="#0078D4"
		/>
		<path
			d="M8.62511 17.6256C8.95716 16.918 9.49334 16.3258 10.1644 15.9251C10.908 15.4994 11.7547 15.2874 12.6112 15.3121C13.4044 15.2946 14.1874 15.4957 14.8741 15.8932C15.5203 16.2781 16.0408 16.8426 16.3721 17.5179C16.7329 18.2619 16.9129 19.0806 16.8971 19.9074C16.9147 20.7715 16.7293 21.6279 16.3562 22.4076C16.0177 23.1067 15.4815 23.6916 14.8141 24.0894C14.1007 24.4994 13.2885 24.706 12.4658 24.6865C11.6554 24.7057 10.8551 24.5024 10.1522 24.0986C9.50097 23.7131 8.9742 23.1481 8.63547 22.4713C8.27234 21.7379 8.09029 20.9281 8.10488 20.1099C8.08879 19.2531 8.26702 18.4038 8.62606 17.6256H8.62511ZM10.2656 21.6172C10.4427 22.0646 10.7431 22.4529 11.1319 22.7365C11.5275 23.0136 12.0017 23.1565 12.4845 23.1444C12.9988 23.1647 13.506 23.0173 13.9291 22.7244C14.3131 22.4407 14.6056 22.0505 14.7701 21.6022C14.955 21.1026 15.0461 20.5731 15.0391 20.0405C15.0448 19.5032 14.9592 18.9686 14.786 18.46C14.6333 18.0021 14.3513 17.5979 13.9741 17.2967C13.5622 16.9891 13.0564 16.8328 12.5427 16.8542C12.0495 16.8414 11.5646 16.9851 11.1581 17.2648C10.7621 17.5494 10.455 17.9409 10.2731 18.3935C9.87079 19.4297 9.86847 20.5795 10.2665 21.6172H10.2656Z"
			fill="white"
		/>
	</svg>
);
